import { connect } from "react-redux"
import { Route, Routes } from "react-router-dom"

import PersistentToken from "components/app/PersistentToken"
import Challenge from "components/challenges/Challenge"
import PublicChallenges from "components/challenges/PublicChallenges"
import Entry from "components/entry/Entry"
import Idea from "components/ideas"
import { LoggedOutInvitation } from "components/users/Invitations"
import UserUnsubscribe from "components/users/Unsubscribe"

import CustomPage from "./CustomPage"

const NonUserSwitch = ({ user, showLogin, gettingUserError }) => {
  if (!user && (showLogin || !gettingUserError)) {
    return (
      <Routes>
        <Route path="unsubscribe" element={<UserUnsubscribe />} />
        <Route path="invitations" element={<LoggedOutInvitation />} />
        <Route path="ideas/:id" element={<Idea />} />
        <Route path="challenges/public" element={<PublicChallenges />} />
        <Route path="challenges/:id/*" element={<Challenge />} />
        <Route path="join/:token" element={<PersistentToken />} />
        <Route path="custom-pages/:pageId" element={<CustomPage />} />
        <Route path="*" element={<Entry />} />
      </Routes>
    )
  }
  return null
}

const mapStateToProps = ({ user, auth }) => ({ user, showLogin: auth.showLogin, gettingUserError: auth.errorMessage })

export default connect(mapStateToProps)(NonUserSwitch)
